export default __webpack_public_path__ + "static/media/szafy6.a0696f84.jpg";